<script setup>
import {onMounted, ref} from "vue";
import httpClient from "../lib/http";
import {eachDayOfInterval, endOfWeek, format, set, setDefaultOptions, startOfWeek} from "date-fns";
import {fr} from 'date-fns/locale';
setDefaultOptions( {locale: fr, weekStartsOn: 1} );

const http = httpClient(),
      show_dance = ref( true ),
      show_fitness = ref( true ),
      loading = ref( true ),
      current_date = ref( set( new Date, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 } ) ),
      start = startOfWeek( current_date.value ),
      end = endOfWeek( current_date.value ),
      days = eachDayOfInterval( { start, end } ),
      courses_by_days = ref( [] );

let fetch_courses_signal = null;

async function fetch_courses() {
    try {
        if ( fetch_courses_signal ) {
            fetch_courses_signal.abort('Cancel request');
        }

        fetch_courses_signal = http.signal();

        const params = new URLSearchParams({
            start: format( start, 'yyyy-MM-dd'),
            end: format( end, 'yyyy-MM-dd'),
            course_type: ['dance', 'fitness'],
        });

        let response = await http.get('/api/v1/courses/scheduled?' + params.toString(), {}, {
            signal: fetch_courses_signal.signal
        });

        fetch_courses_signal = null;

        loading.value = false;

        return courses_by_days.value = response.body;
    } catch (e) {
    }
}

onMounted( async () => await fetch_courses() );
</script>

<template>
    <div class="flex flex-col gap-5">
        <div>
            <label class="text-white cursor-pointer">
                <input type="checkbox" class="inline-block mr-2 relative top-0.5 h-4 w-4" v-model="show_dance" :disabled="!show_fitness && show_dance">
                <span>Afficher la danse</span>
            </label>

            <label class="text-white cursor-pointer ml-12">
                <input type="checkbox" class="inline-block mr-2 relative top-0.5 h-4 w-4" v-model="show_fitness" :disabled="!show_dance && show_fitness">
                <span>Afficher le fitness</span>
            </label>
        </div>

        <div class="flex flex-col lg:flex-row w-full gap-x-2 mb-10" :class="{'pointer-events-none opacity-25': loading}">
            <div v-for="(date, i) in days" :key="i"
                 class="flex flex-col w-full"
                 :class="{
                    'hidden': courses_by_days[ i ] === undefined
                 }"
            >
                <div class="bg-purple border-b-2 text-center text-white content-center uppercase p-4 mb-5">
                    <span>{{ format( date, 'eeee' ) }}</span>
                </div>

                <div v-for="(course, index) in courses_by_days[ i ]" :key="index">
                    <div
                        class="text-white text-center p-2 2xl:px-4 mb-2 transition-opacity"
                        :class="{
                            'hidden': ! ( show_dance && course.course_type === 'dance' ) && ! ( show_fitness && course.course_type === 'fitness' ),
                            'bg-dance': course.course_type === 'dance',
                            'bg-fitness': course.course_type === 'fitness',
                        }">
                        <span class="text-xs">{{ course.schedule_start }} - {{ course.schedule_end }}</span>
                        <p class="font-bold uppercase">{{ course.title }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>